import { communicationsStatusPageDetailsEntrypoint } from '@jira/communications__status-page-details/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const StatusPageDetailsPageEntryPoint = createPageEntryPoint({
	main: communicationsStatusPageDetailsEntrypoint,
	topNavigationMenuId: MENU_ID.STATUS_PAGE_MANAGE,
});
